import constants from '../constants'
import API from './API'
import URI from 'urijs'

const Instance = new API(constants.APIEndpoint)

export const apiAction = (payload) => {
  return {
    type: constants.APIAction,
    payload: payload
  }
}

export default {
  platform: Instance.createEntity({ name: 'platform' }),
  examples: Instance.createEntity({ name: 'examples' }),
  sessions: Instance.createEntity({ name: 'sessions' }),
  states: Instance.createEntity({ name: 'state' }),
  shares: Instance.createEntity({ name: 'share' }),

  parents: {
    children: Instance.createEntity({
      name: 'children',
      path: 'parents/children'
    }),

    diplomas: Instance.createEntity({
      name: 'parents/diplomas',
      path: 'parents/diplomas',
      collection: [
        { name: 'download' }
      ]
    }),

    pretend: Instance.createEntity({
      name: 'pretend',
      path: 'parents/children/:id/pretend'
    }),

    statistics: Instance.createEntity({
      name: 'statistics',
      path: 'parents/statistics'
    })
  },

  teachers: {
    classes: Instance.createEntity({
      name: 'classes',
      path: 'teachers/classes'
    }),

    learners: Instance.createEntity({
      name: 'learners',
      path: 'teachers/classes/:class_id/learners'
    }),

    statistics: Instance.createEntity({
      name: 'statistics',
      path: 'teachers/classes/:class_id/tours/:tour/statistics'
    }),

    tasks: Instance.createEntity({
      name: 'teachers/tasks',
      path: 'teachers/olympiads/:olympiad_id/tasks/:id'
    }),

    answer: Instance.createEntity({
      name: 'teacher/answer',
      path: 'teachers/olympiads/:olympiad_id/tasks/:id/answer',
      member: [
        { name: 'correct' }
      ]
    }),

    profile: Instance.createEntity({
      name: 'teacher_profile',
      path: 'teachers/profile'
    }),

    diplomas: Instance.createEntity({
      name: 'teacher/diplomas',
      path: 'teachers/classes/:class_id/diplomas',
      collection: [
        { name: 'download' },
        { name: 'certificate' }
      ]
    }),

    diplomasStatistics: Instance.createEntity({
      name: 'diplomasStatistics',
      path: 'teachers/diplomas/statistics'
    }),
  },

  students: {
    participations: Instance.createEntity({
      name: 'participations',
      path: 'students/tours/:tour/participations'
    }),

    restarts: Instance.createEntity({
      name: 'restarts',
      path: 'students/tours/:tour/restart'
    }),

    tasks: Instance.createEntity({
      name: 'students/tasks',
      path: 'students/tours/:tour/tasks'
    }),

    ratings: Instance.createEntity({
      name: 'ratings',
      path: 'students/tasks/:id/ratings'
    }),

    answer: Instance.createEntity({
      name: 'answer',
      path: 'students/tours/:tour/tasks/:id/answer',
      member: [
        { name: 'correct' }
      ]
    })
  }
}
